import { getShowAnglerField, getShowCrewField } from "./vtrTrip";
import moment from "moment";
import { getMaxDate, getMinDate } from "./dateFunctions";

export const validateNewTripSet1 = function (tripData) {
  console.group("validateNewTripSet1");
  let error1 = validateVessel(tripData);
  console.error("vessel", error1);
  let error2 = validateDateSail(tripData);
  console.error("date_sail", error2);
  let errors = error1.concat(error2);
  console.error("errorTotal", errors);
  console.groupEnd();
  return errors;
};

export const validateNewTripSet2 = function (tripData) {
  console.group("validateNewTripSet2");
  let allErrors = [];
  let errors = validateTripType(tripData);
  console.error("tripType", errors);
  let [errors2, showCrew] = validateNumberOfCrew(tripData);
  console.error("crew", errors2, showCrew);
  let [errors3, showAnglers] = validateNumberOfAnglers(tripData);
  console.error("anglers", errors2, showAnglers);
  let errors4 = validateOperator(tripData);
  console.error("operator", errors4);
  allErrors = errors.concat(errors2, errors3, errors4);
  console.error("errorTotal", allErrors);
  console.groupEnd();
  return [showCrew, showAnglers, allErrors];
};
export const validateTripType = function (tripData) {
  let errors = [];
  if (tripData.trip_type === "") {
    errors[errors.length] = "No Trip type provided";
  }
  return errors;
};
export const validateNumberOfCrew = function (tripData) {
  let errors = [];
  let showCrew = getShowCrewField(tripData.trip_type);
  if (showCrew === true) {
    if (Number.isNaN(tripData.number_of_crew) || !tripData.number_of_crew) {
      errors[errors.length] = "No number of Crew provided";
    } else if (
      !Number.isInteger(Number(tripData.number_of_crew)) ||
      Number(tripData.number_of_crew) < 1
    ) {
      errors[errors.length] = "Invalid number of Crew provided";
    }
  }
  return [errors, showCrew];
};
export const validateNumberOfAnglers = function (tripData) {
  let errors = [];
  let showAnglers = getShowAnglerField(tripData.trip_type);
  if (showAnglers === true) {
    if (Number.isNaN(tripData.number_of_anglers) || !tripData.number_of_anglers) {
      errors[errors.length] = "No number of Anglers provided";
    } else if (
      !Number.isInteger(Number(tripData.number_of_anglers)) ||
      Number(tripData.number_of_anglers) < 1
    ) {
      errors[errors.length] = "Invalid number of Anglers provided";
    }
  }
  return [errors, showAnglers];
};
export const validateTripSet1 = function (tripData) {
  console.group("validateTripSet1");
  let allErrors = [];
  let error1 = validateTripType(tripData);

  let [error2, showCrew] = validateNumberOfCrew(tripData);
  let [error3, showAnglers] = validateNumberOfAnglers(tripData);
  let error4 = validateOperator(tripData);

  allErrors = error1.concat(error2, error3, error4);
  console.error("totalErrors", allErrors);
  console.groupEnd();
  return allErrors;
};

export const validateOperator = function (tripData) {
  let errors = [];
  if (tripData.operator_permit_number === "" && Number(tripData.trip_type) !== 6) {
    errors[errors.length] = "No Operator provided";
  }
  return errors;
};
export const validateTripSet2 = function (tripData) {
  let errors = validateVessel(tripData);
  let errors2 = validateOperator(tripData);
  let errors3 = validateTripType(tripData);

  return [...errors3, ...errors, ...errors2];
};

export const validateVessel = function (tripData) {
  let errors = [];
  if (tripData.vessel_permit_num === "") {
    errors[errors.length] = "No permit number provided";
  }
  return errors;
};
export const validateTripSet3 = function (tripData) {
  return validateDateSail(tripData);
};
export const validateDateSail = function (tripData) {
  let errors = [];

  if (tripData.date_sail === "" || tripData.date_sail === null) {
    errors[errors.length] = "No date sail provided";
  } else {
    let savedDateSail = moment(tripData.date_sail, "YYMMDDHHmm");
    let minDate = getMinDate();
    if (savedDateSail < minDate) {
      errors[errors.length] = "Date sail before minimum date sail";
    }
    let maxDate = getMaxDate();
    if (savedDateSail > maxDate) {
      errors[errors.length] = "Date sail after maximum date sail";
    }
  }
  return errors;
};
